import {CLEAR_EMPLOYEE_DETAIL_INFORMATION} from "../../../enums/MyDivision/EmployeeList/EmployeeListTypes";

export const clearEmployeeDetailInformationAction =  () => {
    return {
        type: CLEAR_EMPLOYEE_DETAIL_INFORMATION,
    };
};
